<div class="legend" [class.dark-theme]="isDarkTheme">
  @for (item of items; track item) {
    <div class="legend-item" >
      <div class="legend-color" [class]="item.color" [class.dark-theme]="isDarkTheme"></div>
      <span>{{ item.label | translate }}</span>
    </div>
  }

</div>